import { RootState } from '../../../store';

export const getCourseSelector = (state: RootState) => state.course.course;
export const getLoadingCourseSelector = (state: RootState) => state.course.isLoading;
export const getCourseErrorsSelector = (state: RootState) => state.course.errors;
